import axios from "axios";
import getApiBaseUrl from "helpers/getApiBaseUrl";
import ICountryType from "amnShared/addresses/models/ICountryType";
import { IEGPTaxUnit, IUnit, IUnitsGroup } from "./units/IUnitsGroup";
import {
  IActivateTaxSystem,
  ILinkPosDevice,
  ITaxSystem,
} from "./settingTaxes/ITaxSystem";
import taxesAPI from "adminPanel/taxes/taxesAPI";
import { INumbersCard } from "./numbers/INumbersCard";
import { IOrganizationsSettings } from "./ICurrencyType";
import { IBusinessInfo } from "./BusinessInfo/IBusinessInfo";

const baseUrl = getApiBaseUrl();

function GetAllCountries() {
  return axios.get<ICountryType[]>(`${baseUrl}countries`);
}

function GetAllCurrencies() {
  return axios.get(`${baseUrl}currencies`);
}

function AddCountry(id: string) {
  return axios.post<string>(`${baseUrl}countries/${id}`);
}

function ToggleCountryActive(id: string, isActive: boolean) {
  return axios.post(`${baseUrl}countries/toggle-active`, { id, isActive });
}

function ToggleCurrencyActive(id: string, isActive: boolean) {
  return axios.post(`${baseUrl}currencies/toggle-active`, { id, isActive });
}

function AddCurrency(model: any) {
  return axios.post<string>(`${baseUrl}currencies`, { Currency: model });
}

function DeleteCountry(countryId: string) {
  return axios.get(baseUrl + `Countries/delete-country/${countryId}`);
}

function getCountrySubdivisions(countryId: string) {
  return axios.get(baseUrl + `Countries/get-country-subdivisions/${countryId}`);
}

function EditCurrencies(
  currencies: { ExchangeFactor: number; currencyId: string }[],
) {
  return axios.post(baseUrl + `currencies/edit-list/`, { dtos: currencies });
}

function GetStandardUnitsGroup(groupId: string) {
  return axios.get<IUnitsGroup>(
    `${baseUrl}constants/satandard-units-group/${groupId}`,
  );
}

function CreateUnitsGroup(unitsGroup: IUnitsGroup) {
  return axios.post<string>(`${baseUrl}Units/new`, unitsGroup);
}

function EditStandardUnitGroup(unitsGroup: IUnitsGroup) {
  return axios.post<string>(
    `${baseUrl}units/edit-standrd-unit-group`,
    unitsGroup,
  );
}
function GetUnitsGroup(groupId: string) {
  return axios.get<IUnitsGroup>(`${baseUrl}units/units-group/${groupId}`);
}
function ValidateUnit(unit: IUnit) {
  return axios.post<boolean>(`${baseUrl}units/validate-unit`, unit);
}
function CanDeleteUnit(selections: any) {
  return axios.post(`${baseUrl}units/can-delete-unit`, {
    selected: selections,
  });
}

function ActivateTaxSystem(taxSystemData: IActivateTaxSystem) {
  return taxesAPI.ActivateTaxSystem(taxSystemData);
}

function GetActiveTaxSystem() {
  return taxesAPI.GetActiveTaxSystem();
}

function LinkPosDevice(linkData: ILinkPosDevice) {
  return taxesAPI.LinkPosDevice(linkData);
}

function GetPOSsDevices() {
  return taxesAPI.GetPOSsDevices();
}

function GetOrganizationsSettings() {
  return axios.get<IOrganizationsSettings>(
    baseUrl + `OrganizationSettings/get-organization-settings`,
  );
}
function EditNumbersSettings(form: INumbersCard) {
  return axios.post<any>(baseUrl + `Numbers/edit-numbers-settings`, form);
}
function GetBusinessInfo() {
  return axios.get<any>(baseUrl + `BusinessInfo`);
}
function EditBusinessInfo(dto: any) {
  return axios.post<string>(baseUrl + `BusinessInfo/edit`, { dto });
}
function GetEGPTaxUnits() {
  return axios.get<IEGPTaxUnit[]>(baseUrl + `Units/get-egp-tax-units`);
}
function GenerateEGPApiKey() {
  return axios.post<string>(baseUrl + `EGPTaxes/generate-api-key`);
}
const settingsAPI = {
  GetAllCountries,
  GetAllCurrencies,
  GetStandardUnitsGroup,
  AddCountry,
  ToggleCountryActive,
  ToggleCurrencyActive,
  AddCurrency,
  DeleteCountry,
  getCountrySubdivisions,
  EditCurrencies,
  CreateUnitsGroup,
  EditStandardUnitGroup,
  GetUnitsGroup,
  ValidateUnit,
  CanDeleteUnit,
  ActivateTaxSystem,
  GetActiveTaxSystem,
  GetOrganizationsSettings,
  EditNumbersSettings,
  GetBusinessInfo,
  EditBusinessInfo,
  LinkPosDevice,
  GetPOSsDevices,
  GetEGPTaxUnits,
  GenerateEGPApiKey,
};

export default settingsAPI;
